import styled from "styled-components";

export default styled.td`
  background: #cccccc !important;
`;
